import React from 'react';
import genBbqAnalysisReportHtml from './genBbqAnalysisReportHtml';

const GenBbqAnalysisReport: React.FC = () => {
  return (
    <iframe
      srcDoc={genBbqAnalysisReportHtml}
      title="Gen Korean BBQ Server Performance — Deep Analysis"
      style={{ width: '100%', height: '100vh', border: 'none' }}
    />
  );
};

export default GenBbqAnalysisReport;
